import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { odbRoutePathList } from './../app-routing.module';
import { SelectedOdbDetailsInfo } from '../my-bill/models/pii.model';
import {
  ODB_DETAILS_SESSION_DATA_KEY,
  UtilsService,
} from '../my-bill/services/utils.service';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsMessageInfoResolverService {
  constructor(private utilsService: UtilsService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string {
    let billingAccountNumber = route.paramMap.get('billingAccountNumber');
    if (!billingAccountNumber) {
      const documentFromSessionStorage =
        this.utilsService.getInfoFromSessionStorage<SelectedOdbDetailsInfo>(
          ODB_DETAILS_SESSION_DATA_KEY
        );

      billingAccountNumber =
        documentFromSessionStorage?.billingAccount.accountNumber ?? '';
    }
    if (!route.data.analytics.message) {
      route.data.analytics.message = {};
    }
    route.data.analytics.message.info = billingAccountNumber;
    return billingAccountNumber;
  }
}
